import { render, staticRenderFns } from "./ForumListing.vue?vue&type=template&id=b630faea&scoped=true&"
import script from "./ForumListing.vue?vue&type=script&lang=js&"
export * from "./ForumListing.vue?vue&type=script&lang=js&"
import style0 from "./ForumListing.vue?vue&type=style&index=0&id=b630faea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b630faea",
  null
  
)

export default component.exports